import { useState } from 'react'
import { FaqGamerPage } from './FaqGamerPage'
import { ExpertVideosPage } from '../../facilitator/pages/ExpertVideosPage'

/**
 * QAGamerPage component - Wrapper for FAQ and Expert Videos
 * Handles navigation between FAQ view and Expert Videos view
 */
export const QAGamerPage = () => {
  const [currentView, setCurrentView] = useState<'faq' | 'videos'>('faq')

  const handleNavigateToVideos = () => {
    setCurrentView('videos')
  }

  const handleNavigateToFaq = () => {
    setCurrentView('faq')
  }

  if (currentView === 'videos') {
    return <ExpertVideosPage onBackToFaq={handleNavigateToFaq} showArticles={false} />
  }

  return <FaqGamerPage onNavigateToVideos={handleNavigateToVideos} />
}
